"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResponsive2 = exports.useResponsive = void 0;
var React = __importStar(require("react"));
var models_1 = require("../../models");
var services_1 = require("../../services");
var context_1 = require("../context");
/**
 * Handles the registration/unregistration of the responsiveService
 * @param responsiveObject generic breakpoint mapping or constant to map to a specific object
 * @param callback a function to call with the mapped object
 * @deprecated This is not exported from GDS. Please do not do so now.
 */
var useResponsive = function (responsiveObject, callback) {
    var responsiveToken = React.useRef();
    React.useEffect(function () {
        responsiveToken.current = services_1.responsiveService.registerListener(responsiveObject, callback);
        return function () {
            return responsiveToken.current && responsiveToken.current.unregister();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [responsiveObject]);
};
exports.useResponsive = useResponsive;
// --- END OLD VERSION ---
var bps = [
    models_1.Breakpoint.XS,
    models_1.Breakpoint.SM,
    models_1.Breakpoint.MD,
    models_1.Breakpoint.LG,
    models_1.Breakpoint.XL,
];
var isBPMapping = function (item) {
    return (item &&
        typeof item === "object" &&
        Object.keys(item).every(function (key) { return bps.includes(key); }));
};
/**
 * Resolves a breakpoint mapping of T to a specific T based on the current breakpoint.
 * @param item breakpoint mapping (or object) that should be resolved
 *
 * @remarks
 * - You may explicitly map breakpoints to `null`, but not `undefined`
 * - Because this cascades from small to large breakpoints, you do not need to include every
 * Breakpoint in the mapping, but you should at least include a mapping for Breakpoint.XS.
 * - This hook can also take a T which will simply pass through.
 *
 * @example
 * // To switch between hypothetical layout components based on breakpoint:
 * const layout = useResponsive({xs: Layout.Vertical, lg: Layout.Horizontal});
 * return (layout === Layout.Vertical)
 *   ? <Vertical>{content}</Vertical>
 *   : <Horizontal>{content}</Horizontal>
 *
 * // val will be undefined at Breakpoint.XS because of cascading behavior:
 * const val = useResponsive({ sm: false, lg: true });
 *
 * // val will be null at all breakpoints because undefined mappings are ignored:
 * const val = useResponsive({ xs: null, md: undefined });
 */
var useResponsive2 = function (item) {
    var windowSizeCtx = React.useContext(context_1.WindowSizeContext);
    if (isBPMapping(item)) {
        var value = void 0;
        for (var _i = 0, bps_1 = bps; _i < bps_1.length; _i++) {
            var bp = bps_1[_i];
            value = item[bp] !== undefined ? item[bp] : value;
            if (bp === windowSizeCtx.currentBreakpoint) {
                break;
            }
        }
        return value;
    }
    else {
        return item;
    }
};
exports.useResponsive2 = useResponsive2;
exports.default = exports.useResponsive2;
